import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueSmoothScroll from 'vue2-smooth-scroll'

import '@/assets/scss/main.scss'
Vue.config.productionTip = false

Vue.use(VueSmoothScroll)


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
